import { Outlet } from 'react-router-dom';

export function AppLayout() {
  return (
    <div className="flex h-full flex-col bg-bg-primary overflow-hidden">
      <div className="flex flex-1 overflow-hidden">
        <Outlet />
      </div>
    </div>
  );
}
